import React from "react";
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import heatOn  from "../images/heat_on.svg";
import heatOff  from "../images/heat_off.svg";

function Disabled({ disabled, children }) {
  if (disabled) {
    return (
      <div style={{ opacity: 0.3, pointerEvents: "none" }} disabled>
        {children}
      </div>
    );
  }
  return <React.Fragment>{children}</React.Fragment>;
}

const Heat = ({ value, title, desc, disabled }) => {
    if(value === "true")
    {
        return (
                  <Disabled disabled={disabled}>
                    <Stack direction="column" align="left" spacing={1}>
                      <img
                        src={heatOn}
                        alt={title}
                        loading="lazy"
                        style={
                          {
                            width: 60,
                            height: '100%',
                          }
                        }
                      />
                      <Typography variant="caption" >
                        {desc}
                      </Typography>
                  <Typography variant="subtitle2">
                    ON
                  </Typography>
                  </Stack>
                </Disabled>
          );
    }
    else
    {
        return (
              <Disabled disabled={disabled}>
                <Stack direction="column" align="left" spacing={1} >
                <img
                        src={heatOff}
                        alt={title}
                        loading="lazy"
                        style={
                          {
                            width: 60,
                            height: '100%',
                          }
                        }
                      />
                      <Typography variant="caption">
                        {desc}
                      </Typography>
                    <Typography variant="subtitle2">
                      OFF
                    </Typography>
                  </Stack>
              </Disabled>
          );
    }
  
};

export default Heat;
